(function() {
	'use strict';
	
	function initPasswordToggle() {
		// Find ALL login forms on the page (both drawer and page view)
		const loginForms = document.querySelectorAll('#login[data-form-type="login"]');
		
		loginForms.forEach(function(loginForm) {
			const passwordToggle = loginForm.querySelector('.password-toggle-login');
			const passwordInput = loginForm.querySelector('#login_password');
			
			// Skip if already initialized or elements don't exist
			if (!passwordToggle || !passwordInput || passwordToggle.hasAttribute('data-initialized')) {
				return;
			}
						
			// Clone to remove any existing listeners
			const newToggle = passwordToggle.cloneNode(true);
			passwordToggle.parentNode.replaceChild(newToggle, passwordToggle);
			
			// Mark as initialized
			newToggle.setAttribute('data-initialized', 'true');
			
			const openIcon = newToggle.querySelector('.eye-icon-open');
			const closedIcon = newToggle.querySelector('.eye-icon-closed');
			
			if (!openIcon || !closedIcon) {
				return;
			}
			
			// Set initial visibility
			openIcon.style.display = 'block';
			closedIcon.style.display = 'none';
			
			newToggle.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				if (passwordInput.type === 'password') {
					passwordInput.type = 'text';
					openIcon.style.display = 'none';
					closedIcon.style.display = 'block';
				} else {
					passwordInput.type = 'password';
					openIcon.style.display = 'block';
					closedIcon.style.display = 'none';
				}
			});
			
		});
	}
	
	// Method 1: Initialize on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initPasswordToggle);
	} else {
		initPasswordToggle();
	}
	
	// Method 2: Watch entire document for new nodes (catches drawer content)
	const bodyObserver = new MutationObserver(function(mutations) {
		let shouldInit = false;
		
		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				// Check if added node contains login form
				if (node.nodeType === 1) { // Element node
					if (node.id === 'login' || 
					    (node.querySelector && node.querySelector('#login[data-form-type="login"]'))) {
						shouldInit = true;
					}
				}
			});
		});
		
		if (shouldInit) {
			setTimeout(initPasswordToggle, 50);
		}
	});
	
	// Start observing the entire body
	if (document.body) {
		bodyObserver.observe(document.body, {
			childList: true,
			subtree: true
		});
	} else {
		document.addEventListener('DOMContentLoaded', function() {
			bodyObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		});
	}
	
	// Method 3: Watch for drawer specifically
	function watchDrawer() {
		const drawer = document.getElementById('Account-Drawer');
		if (!drawer) {
			return;
		}		
		const drawerObserver = new MutationObserver(function() {
			setTimeout(initPasswordToggle, 100);
		});
		
		drawerObserver.observe(drawer, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'style']
		});
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watchDrawer);
	} else {
		watchDrawer();
	}
	
	// Method 4: Periodic checking (fallback)
	let attempts = 0;
	const checkInterval = setInterval(function() {
		attempts++;
		
		const uninitializedToggles = document.querySelectorAll('.password-toggle-login:not([data-initialized])');
		
		if (uninitializedToggles.length > 0) {
			initPasswordToggle();
		}
		
		// Stop after 30 seconds
		if (attempts > 60) {
			clearInterval(checkInterval);
		}
	}, 500);
	
	// Method 5: Listen for clicks on drawer triggers
	document.addEventListener('click', function(e) {
		const target = e.target;
		
		// Check if clicked element or parent opens account drawer
		if (target.closest('[href*="account"]') || 
		    target.closest('.account-link') ||
		    target.closest('[data-account-drawer]')) {
			console.log('Account link clicked, will check for form');
			setTimeout(initPasswordToggle, 300);
		}
	});
	
	// Method 6: Listen for Shopify events
	document.addEventListener('shopify:section:load', function() {
		setTimeout(initPasswordToggle, 100);
	});
	
	// Method 7: Global function that can be called manually
	window.initPasswordToggle = initPasswordToggle;
})();